"use strict";

//import toggleSubMenu from "./scripts/toggleSubMenu";
//import headerScrolling from "./scripts/headerScrolling";

import * as dom from "./scripts/lib/dom";
import AOS from "aos";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";

import mobileMenu from "./scripts/menu/mobileMenu";
import subMenu from "./scripts/menu/subMenu";
import popupQmSomos from "./scripts/popupQmSomos";
import numIncrement from "./scripts/numIncrement";
import acessoRapido from "./scripts/acessoRapido";

//toggleSubMenu();
//headerScrolling();

AOS.init({
    once: true,
});

mobileMenu();
subMenu();
popupQmSomos();
numIncrement();
acessoRapido();
